<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('016002001') !== -1" />
      </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="缴费项" @search="searchKey" />
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @goToModifyPage="toModifyPage" @deleteLine="deleteLine" deleteTipInfo="是否确认删除该配置？" :operationArr="operationArr"  />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/invoice'
  import {bus} from '../../../utils/bus'
  import {errorHandler} from '../../../utils/errorHandler'
  import ButtonAdd from '../../../components/common/buttons/button-add'
  import {nSuccess} from '../../../utils/notice'

  export default {
    components: {
      ButtonAdd,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      Breadcrumb},
    name: 'invoice-tax-rate-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧凭证',
          name: 'invoice-over-view'
        }, {
          value: '税率管理'
        }],
        exportUrl: '',
        addPageName: 'invoice-tax-rate-add',
        tableHead: [{
          prop: 'itemName',
          label: '缴费项'
        }, {
          prop: 'invoiceName',
          label: '开票名称'
        }, {
          prop: 'taxRate',
          label: '税率'
        }, {
          prop: 'resellerName',
          label: '销方'
        }, {
          prop: 'typeCode',
          label: '分类编码'
        }, {
          prop: 'unit',
          label: '单位'
        }],
        operationArr: ['modify', 'delete'],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        uploadUrl: '',
        selectionArr: [],
        requestData: {
          searchKey: '',
        }
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.uploadUrl = api.importPaymentItemBill
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      toAddPage () {
        this.$router.push({
          name: 'invoice-tax-rate-add'
        })
      },
      toModifyPage (code) {
        this.$router.push({
          path: '/invoice_tax_rate_modify/' + code
        })
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getInvoiceTaxRatePage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                v.code = v.itemCode
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      deleteLine (code) {
        this.$axios.post(api.deleteInvoiceTaxRateByCodes, code)
          .then(res => {
            nSuccess('删除成功')
            this.getPage()
          })
          .catch(errorHandler('删除失败'))
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Invoice/InvoiceTaxRate/InvoiceTaxRateManage.vue